import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export function getMinTransactionDateQueryKey () {
  return ['reimbursements', 'reimbursement', 'min_allowed_transaction_date']
}

export function useGetMinTransactionDate () {
  return useQuery<Date, GrapeAPIErrorType>({
    queryKey: getMinTransactionDateQueryKey(),
    queryFn: async () => {
      const response = await fetchWithHeaders('/api/web/reimbursements/min_allowed_transaction_date')
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      const { date } = await response.json()
      return new Date(date)
    },
  })
}
